import * as React from "react";
import { SVGProps, memo } from "react";

const SvgGuide = (props: SVGProps<SVGSVGElement>) => (
  <svg width={41} height={40} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="m16.675 34.965-9.13-5.595A2.19 2.19 0 0 1 6.5 27.5V6.9a2.185 2.185 0 0 1 3.325-1.865l9.13 5.595A2.189 2.189 0 0 1 20 12.5v20.6a2.184 2.184 0 0 1-3.325 1.865Z"
      fill="#FFC800"
    />

    <path
      d="m24.825 34.905 9.13-5.6A2.174 2.174 0 0 0 35 27.445V6.835A2.185 2.185 0 0 0 31.675 5l-9.13 5.57a2.175 2.175 0 0 0-1.045 1.86v20.61a2.184 2.184 0 0 0 3.325 1.865Z"
      fill="#00A99D"
    />
  </svg>
);

const Memo = memo(SvgGuide);

export default Memo;
